import { schedulePostHogInitialization } from '@/lib/posthog-runtime';

schedulePostHogInitialization();
